import { useState } from 'react';
import FavoriteIndicator from './FavoriteIndicator';
import MealCard from './MealCard';


const Meal = ({ meal, toggleMealCard, setFavorite}) => {

    return (
        <div className="flex-only">
            <div className='meal'>
                <div className="flex">
                    <h3 className="meal-title width85" onClick={ () => {toggleMealCard(meal) }}>{meal.title}</h3>
                    <FavoriteIndicator meal = {meal} setFavorite = {setFavorite} className="width10"></FavoriteIndicator>
                </div>
            </div>
        </div>
    )
}

export default Meal
